export default "__VITE_ASSET__SMHEaJ0t__"